module.exports = __webpack_public_path__ + "static/media/nomanishaq.4c031fff.jpeg";